import { Routes } from '@angular/router';
import { AuthGuard } from '../../guard/auth-guard/auth.guard';
import { RoleChildGuard } from '../../guard/auth-guard/role-child.guard';
import { Role } from '../../core/enums/role.enum';

export const perfisRoutes: Routes = [
  {
    path: 'perfis',
    canActivate: [AuthGuard],
    canActivateChild: [RoleChildGuard],
    children: [
      {
        path: '',
        loadComponent: () =>
          import('./perfis.component').then((m) => m.PerfisComponent),
        data: {
          title: 'Administração de Perfis e Permissões',
          roles: [Role.PERFIS_CONSULTAR],
          breadcrumb: [{ label: 'Perfil', url: '/perfis' }],
        },
      },
      {
        path: 'cadastrar',
        loadComponent: () =>
          import('./perfil-form/perfil-form.component').then(
            (m) => m.PerfilFormComponent,
          ),
        data: {
          title: 'Cadastrar Perfil',
          roles: [Role.PERFIS_CADASTRAR],
          breadcrumb: [
            { label: 'Perfil', url: '/perfis' },
            { label: 'Cadastrar', url: '/perfis/cadastrar' },
          ],
        },
      },
      {
        path: 'editar/:id',
        loadComponent: () =>
          import('./perfil-form/perfil-form.component').then(
            (m) => m.PerfilFormComponent,
          ),
        data: {
          title: 'Editar Perfil',
          roles: [Role.PERFIS_EDITAR],
          breadcrumb: [
            { label: 'Perfil', url: '/perfis' },
            { label: 'Editar', url: '/perfis/editar' },
          ],
        },
      },
    ],
  },
];
